// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import SideNavLayout from "../customsidenav/sidenavlayout";
// import { faSearch, faXmark } from "@fortawesome/free-solid-svg-icons";
// import { useCallback, useEffect, useRef, useState } from "react";
// import { Backdrop, CircularProgress, Skeleton } from "@mui/material";
// import TabsComponent from "../rpm/tabs";
// import { BiList, BiListTask, MaterialSymbols } from "../utils/gridbuttons/gridbutton";
// import calendericon from "../assets/auth/calendericon.svg";
// import { customObjectToDateString } from "../dateutils/date";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import MiniCards from "./cards/cards";
// import FullViewCard from "./cards/fullcard";
// import FilterAltIcon from "@mui/icons-material/FilterAlt";
// import dayjs from "dayjs";
// import api from "../api/api";
// import TaskFilter from "./Modals/TaskFilter";
// import { FilterAltOutlined } from "@mui/icons-material";
// import { filteroutlined } from "../customsidenav/svgslist";
// import isToday from "dayjs/plugin/isToday";
// import ToastMessage from "../utils/mui/righttoptoast";
// import { useSelector } from "react-redux";
// dayjs.extend(isToday);

// const Tasks = () => {
//   const [loading, setLoading] = useState(false);
//   const [selectedTab, setSelectedTab] = useState(0);
//   const calendarRef = useRef(null);
//   const [isCardView, setIsCardView] = useState(!false);
//   const [selectedDate, setSelectedDate] = useState(dayjs());
//   const today = new Date();
//   const [isCalendarOpen, setIsCalendarOpen] = useState(false);
//   const [taskFilter, setTaskFilter] = useState(false);
//   const [selectedFilter, setSelectedFilter] = useState("All");
//   const [tasks, setTasks] = useState([]);
//   console.log("tasks",tasks);

//   const [originalTask, setOriginalTask] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedTask, setSelectedTask] = useState({});
//   const [markascomplete, setMarkascomplete] = useState({});
//   const [markcancel, setMarkcancel] = useState({});
//   const [scheduleStates, setScheduleStates] = useState({});
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const practiseid = getPracticeId();
//   const [isFilterApplied, setIsFilterApplied] = useState(false);
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState([]);
//   const [loginuser, setLoginuser] = useState({});
//   const userConfig = useSelector((state) => state.userconfig);
//   const [tabs, setTabs] = useState([
//     { label: "All Tasks", width: 44, count: 0, status: "All" }, // Tab for "All Tasks"
//     { label: "Pending", width: 64, count: 0, status: "INFO" }, // Tab for "Pending" tasks
//     { label: "Flagged", width: 64, count: 0, status: "FLAGGED" }, // Assuming there's a Flagged tab
//   ]);

//   const [openToast, setOpenToast] = useState(false);
//   const [toastMessage, setToastMessage] = useState("");

//   const [toastSeverity, setToastSeverity] = useState("success");
//   const handleToastClose = () => {
//     setOpenToast(false);
//   };

//   useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (calendarRef.current && !calendarRef.current.contains(event.target)) {
//       setIsCalendarOpen(false);
//     }
//   };

//   if (isCalendarOpen) {
//     document.addEventListener("mousedown", handleClickOutside);
//   } else {
//     document.removeEventListener("mousedown", handleClickOutside);
//   }

//   return () => {
//     document.removeEventListener("mousedown", handleClickOutside);
//   };
// }, [isCalendarOpen]);

//   const handleDateChange = (date) => {
//     setSelectedDate(date);
//     setIsCalendarOpen(false);
//     fetchdbcounts(date);
//     fetchdata({ dt: date.format("YYYY-MM-DD"), st: selectedFilter });
//   };
//   const fetchuser = async () => {
//     try {
//       const response = await api.get(`auth/me`);
//       setLoginuser(response);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const fetchdata = async ({
//     dt = null,
//     st = null,
//     ct = [],
//     searchQuery = "",
//     isfilter,
//   }) => {
//     // selectedDate.format('YYYY-MM-DD')
//     if (st === null) {
//       setSelectedTab(0);
//     } else {
//       setSelectedFilter(st);
//     }
//     setLoading(true);

//     try {
//       const payload = {
//         orderdate: dt || selectedDate.format("YYYY-MM-DD"),
//         search: "",
//       };

//       if (st) {
//         payload.status = [st];
//       } else {
//         payload.status = ["All"];
//       }

//       payload.category = ct;

//       const response = await api.post(`/v1/${practiseid}/tasks`, payload);

//       // if (response.status == 200) {
//       //   setTasks(response.data);
//       //   setOriginalTask(response.data);
//       //   if (isfilter) {
//       //     const value = searchQuery.trim().toLowerCase(); // ensure case-insensitive and trimmed

//       //     const filteredTasks = response.data.filter((task) => {
//       //       const nameMatch = task.patient_name?.toLowerCase().includes(value);
//       //       const idMatch = String(task.patientid).includes(value); // convert patientid to string
//       //       return nameMatch || idMatch;
//       //     });

//       //     console.log(filteredTasks, " result -->searchterm", searchQuery);
//       //     setTasks(filteredTasks);
//       //   }
//       // }
//        if (response.status == 200) {
//   const reversed = [...response.data].reverse(); // reverse safely without mutating

//   setTasks(reversed);
//   setOriginalTask(reversed);

//   if (isfilter) {
//     const value = searchQuery.trim().toLowerCase();

//     const filteredTasks = reversed.filter((task) => {
//       const nameMatch = task.patient_name?.toLowerCase().includes(value);
//       const idMatch = String(task.patientid).includes(value);
//       return nameMatch || idMatch;
//     });

//     console.log(filteredTasks, " result -->searchterm", searchQuery);
//     setTasks(filteredTasks);
//   }
// } else {
//         setTasks([]);
//         setOriginalTask([]);
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const fetchdbcounts = async (dt) => {
//     const payloaddate = dt
//       ? dt.format("YYYY-MM-DD")
//       : selectedDate.format("YYYY-MM-DD");
//     try {
//       const response = await api.get(
//         `/v1/${practiseid}/tasks/tasks-top-count?st_date=${payloaddate}`
//       );
//       const { alltaskOrderscnt, pendingtaskOrderscnt, flagtaskOrderscnt } =
//         response.data;
//       setTabs((prevTabs) => [
//         { ...prevTabs[0], count: alltaskOrderscnt },
//         { ...prevTabs[1], count: pendingtaskOrderscnt },
//         { ...prevTabs[2], count: flagtaskOrderscnt },
//       ]);
//     } catch (error) {
//       console.error("Error fetching tasks count:", error);
//     }
//   };

//   useEffect(() => {
//     fetchuser();
//   }, []);

//   const handleSearchChange = (event) => {
//     const value = event.target.value.trim().toLowerCase();
//     setSearchQuery(value);

//     const filteredTasks = originalTask.filter((task) => {
//       const nameMatch = task.patient_name?.toLowerCase().includes(value);
//       const idMatch = String(task.patientid).includes(value); // convert patientid to string for comparison
//       return nameMatch || idMatch;
//     });

//     setTasks(filteredTasks);
//   };

//   let user = localStorage.getItem("user");
//   let firstName = localStorage.getItem("firstname");
//   let lastName = localStorage.getItem("lastname");

//   const markAsComplete = async (ids, task) => {
//     try {
//       // Check if the task is an array or a single task object
//       const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array

//       if (!taskToProcess) {
//         console.error("No task data available");
//         return;
//       }

//       // Extract data from the task (using taskToProcess to ensure consistency)
//       const fullName = `${firstName} ${lastName}`;
//       const payload = {
//         ids: ids,
//         status: taskToProcess.status,
//         notes: taskToProcess.notes,
//         orderdate: dayjs(taskToProcess.ts).format("YYYY-MM-DD"),
//         login_user: user,
//         ordertype: taskToProcess.ordertype,
//         username: userConfig?.username,
//       };

//       // Make API call to mark as complete
//       const response = await api.put(
//         `/v1/${practiseid}/tasks/${taskToProcess.patientid}/mark_as_complete`,
//         payload
//       );

//       if (response.status === 200) {
//         // Refetch the data after completing the task

//         setToastSeverity("success");
//         setToastMessage(response.message);
//         setOpenToast(true);

//         fetchdbcounts(selectedDate);
//         const selected = tabs[selectedTab].status;
//         fetchdata({
//           dt: selectedDate.format("YYYY-MM-DD"),
//           st: selected,
//           ct: selectedCategory,
//           searchQuery,
//           isfilter: true,
//         });
//         console.log("Task marked as complete successfully");
//       } else {
//         setToastSeverity("info");
//         setToastMessage(response.message);
//         setOpenToast(true);
//         console.error("Error marking task as complete");
//       }
//     } catch (error) {
//       setToastSeverity("error");
//       setToastMessage("Something Went Wrong");
//       setOpenToast(true);
//       console.error("Error marking task as complete:", error);
//     }
//   };

//   const markAsFlag = async (ids, task,status) => {
//     try {
//       // Check if the task is an array or a single task object
//       const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array

//       if (!taskToProcess) {
//         console.error("No task data available");
//         return;
//       }

//       const payload = {
//         ids: ids,
//         notes: taskToProcess.notes,
//         st_date: dayjs(taskToProcess.ts).format("YYYY-MM-DD"),
//         login_user: user,
//       };
// let response;
// if(status === "FLAGGED"){
//  response = await api.put(
//         `/v1/${practiseid}/tasks/mark_as_unflagged`,
//         payload
//       );
// }else{
//       // Make API call to mark as complete
//       response = await api.put(
//         `/v1/${practiseid}/tasks/mark_as_flagged`,
//         payload
//       );
// }

//       if (response.status === 200) {
//         // Refetch the data after completing the task

//         setToastSeverity("success");
//         setToastMessage(response.message);
//         setOpenToast(true);

//         fetchdbcounts(selectedDate);
//         const selected = tabs[selectedTab].status;
//         fetchdata({
//           dt: selectedDate.format("YYYY-MM-DD"),
//           st: selected,
//           ct: selectedCategory,
//           searchQuery,
//           isfilter: true,
//         });
//         console.log("Task marked as Flagged");
//       } else {
//         setToastSeverity("info");
//         setToastMessage(response.message);
//         setOpenToast(true);
//         console.error("Error While Flagging the task");
//       }
//     } catch (error) {
//       setToastSeverity("error");
//       setToastMessage("Something Went Wrong");
//       setOpenToast(true);
//       console.error("Error marking task as complete:", error);
//     }
//   };
//   const markAscancel = async (ids, task) => {
//     try {
//       // Check if the task is an array or a single task object
//       const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array

//       if (!taskToProcess) {
//         console.error("No task data available");
//         return;
//       }

//       // Construct the payload for the cancel action
//       const payload = {
//         ids: ids, // Pass the task ids (task.id or array of ids)
//         notes: taskToProcess.notes, // Use notes from the task
//         st_date: dayjs(taskToProcess.ts).format("YYYY-MM-DD"), // Format the timestamp
//         login_user: userConfig?.username, // Logged in user info
//       };

//       // Make API call to mark as decline (cancel)
//       const response = await api.put(
//         `/v1/${practiseid}/tasks/mark_as_decline`,
//         payload
//       );

//       if (response.status === 200) {
//         setToastSeverity("success");
//         setToastMessage(response.message);
//         setOpenToast(true);
//         // Refetch or update data after the cancel action is successful
//         console.log("Task marked as cancelled successfully");
//         fetchdbcounts(selectedDate);
//         const selected = tabs[selectedTab].status;
//         fetchdata({
//           dt: selectedDate.format("YYYY-MM-DD"),
//           st: selected,
//           ct: selectedCategory,
//           searchQuery,
//           isfilter: true,
//         });
//       } else {
//         setToastSeverity("info");
//         setToastMessage(response.message);
//         setOpenToast(true);
//         console.error("Error marking task as cancelled");
//       }
//     } catch (error) {
//       setToastSeverity("error");
//       setToastMessage("Something Went Wrong");
//       setOpenToast(true);
//       console.error("Error marking task as cancelled:", error);
//     }
//   };

//   const handleconfirmScheduleClick = async (order) => {
//     try {
//       // Create the payload to send the status update

//       const newStatusFlag = selectedOrder.schedule === "t" ? "f" : "t"; // Toggle status for this specific order

//       console.log(newStatusFlag);
//       setScheduleStates((prevState) => ({
//         ...prevState,
//         [order.id]: newStatusFlag, // Update only this specific order's status
//       }));

//       // Create the payload to send the status update
//       const payload = {
//         orderid: order.id,
//         statusflag: newStatusFlag,
//         login_user: user, // You can replace with the actual logged-in user
//       };
//       // Call API to update status flag
//       const response = await api.put(
//         `/v1/${practiseid}//tasks/update_status_schedule`,
//         payload
//       );

//       if (response.status === 200) {
//         // If the update was successful, refresh data if necessary
//         fetchdata({
//           dt: selectedDate.format("YYYY-MM-DD"),
//           st: selectedStatus,
//           ct: selectedCategory,
//           searchQuery,
//           isfilter: true,
//         });
//         setScheduleStates({});
//       } else {
//         console.error("Error updating status");
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//     }
//   };

//   useEffect(() => {
//     fetchdbcounts();
//     if (!isFilterApplied) {
//       fetchdata({ dt: selectedDate.format("YYYY-MM-DD"), searchQuery });
//     }
//   }, []);

//   return (
//     <div className="h-full px-5 py-4 bg-[#f1f1f1]">
//       {/* Search bar */}
//       <SideNavLayout>

//       <div className="w-full flex justify-end mb-4">
//         <div className="relative w-full max-w-md flex justify-end">
//           <div className="flex items-center w-[80%] bg-[#F5F6FA] border border-[#D5D5D5] rounded-[15px]">
//             <FontAwesomeIcon icon={faSearch} className="text-gray-400 ml-3" />
//             <input
//               type="text"
//               className="bg-[#F5F6FA] flex-grow py-1 pl-2 pr-3 text-base outline-none rounded-[15px]"
//               placeholder="Search"
//               value={searchQuery} // Bind the input value to searchQuery state
//               onChange={handleSearchChange} // Handle input change
//             />
//           </div>
//         </div>
//       </div>

//       {/* Tabs and right section */}
//       <div className="w-full flex">
//         <div className="flex w-full flex-col gap-3 sm:flex-row sm:gap-0">
//           {/* Left-aligned tabs */}
//           <div className="flex-grow">
//             <TabsComponent
//               tabs={tabs}
//               selectedTab={selectedTab}
//               onSelectTab={(index) => {
//                 setSelectedTab(index);
//                 const selectedStatus = tabs[index].status;
//                 setSearchQuery("");
//                 setSelectedStatus("");
//                 setTasks([]);
//                 fetchdata({
//                   dt: selectedDate.format("YYYY-MM-DD"),
//                   st: selectedStatus,
//                   ct: selectedCategory,
//                   searchQuery,
//                 });
//                 fetchdbcounts(selectedDate);
//               }}
//             />
//           </div>

//           {/* Right-aligned controls */}
//           <div className="flex items-center space-x-4">
//             {/* <BiListTask isCardView={isCardView} setIsCardView={setIsCardView} /> */}
//             {/* <MaterialSymbols
//               isCardView={isCardView}
//               setIsCardView={setIsCardView}
//             /> */}

//               <div
//                 onClick={() => setIsCalendarOpen(!isCalendarOpen)}
//                 className="flex flex-col items-start justify-start px-2 py-1 bg-white rounded-[10px] cursor-pointer"
//               >
//                 {/* <div className="text-sm">
//                     {selectedDate
//                       ? customObjectToDateString(selectedDate)
//                       : new Date().toISOString().split("T")[0]}
//                   </div> */}
//                 <span className="text-[10px] text-[#1D2951] font-worksans font-medium">
//                   {dayjs(selectedDate).isSame(dayjs(), "day")
//                     ? "Today"
//                     : dayjs(selectedDate).format("dddd")}
//                 </span>
//                 <div className="flex justify-between items-center gap-2">
//                   <div className="text-sm">
//                     {selectedDate
//                       ? selectedDate.format("MM.DD.YYYY")
//                       : dayjs().format("MM.DD.YYYY")}
//                   </div>

//                   <img
//                     className="w-5 h-5"
//                     alt="Calendar Icon"
//                     src={calendericon}
//                   />
//                 </div>
//               </div>
//                           <div className="cursor-pointer" onClick={() => setTaskFilter(true)}>
//               {filteroutlined}
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="flex flex-wrap gap-2 mt-4">
//         {/* Category chips */}
//         {selectedCategory.map((item) => (
//           <div
//             key={item}
//             className="flex items-center bg-[#E17954] text-white px-2 py-0.5 rounded-full text-xs"
//           >
//             <span>{item}</span>
//             <button
//               onClick={() => {
//                 const updatedCategories = selectedCategory.filter(
//                   (c) => c !== item
//                 );
//                 setSelectedCategory(updatedCategories);
//                 fetchdata({
//                   ct: updatedCategories,
//                   dt: selectedDate ? selectedDate.format("YYYY-MM-DD") : null,
//                 });
//               }}
//               className="ml-1 focus:outline-none"
//             >
//               &times;
//             </button>
//           </div>
//         ))}

//         {/* Date chip - only show if not today */}
//         {!selectedDate.isToday() && (
//           <div className="flex items-center bg-[#E17954] text-white px-2 py-0.5 rounded-full text-xs">
//             <span>{selectedDate.format("MM-DD-YYYY")}</span>
//             <button
//               onClick={() => {
//                 const today = dayjs();
//                 setSelectedDate(today);
//                 fetchdata({
//                   ct: selectedCategory,
//                   dt: today.format("YYYY-MM-DD"),
//                 });
//               }}
//               className="ml-1 focus:outline-none"
//             >
//               &times;
//             </button>
//           </div>
//         )}
//         {selectedStatus &&
//           selectedStatus !== "All" &&
//           selectedStatus !== "INFO" && (
//             <div className="flex items-center bg-[#E17954] text-white px-2 py-0.5 rounded-full text-xs">
//               <span>{selectedStatus}</span>
//               <button
//                 onClick={() => {
//                   setSelectedTab(0);
//                   setSelectedStatus("All");
//                   fetchdata({
//                     dt: selectedDate.format("YYYY-MM-DD"),
//                     st: "All",
//                     ct: selectedCategory,
//                     searchQuery,
//                   });
//                 }}
//                 className="ml-1 focus:outline-none"
//               >
//                 &times;
//               </button>
//             </div>
//           )}
//         {/* Clear All Button */}
//         {(selectedCategory.length > 0 || !selectedDate.isToday()) && (
//           <button
//             onClick={ async () => {
//               const today = dayjs();
//               setSelectedCategory([]);
//               setSelectedTab(0);
//               setSelectedStatus("All");
//               setSelectedDate(today);
//               await fetchdbcounts(today);
//               fetchdata({
//                 ct: [],
//                 dt: today.format("YYYY-MM-DD"),
//                 st: "All",
//               });
//             }}
//             className="flex items-center justify-center w-8 h-8 rounded-full text-gray-500 text-2xl focus:outline-none"
//             title="Clear All"
//           >
//             <FontAwesomeIcon icon={faXmark} />
//           </button>
//         )}
//       </div>

//       {/* Cards Section - Scrollable */}
//       <div
//         className="w-full flex flex-wrap gap-6 custom-scrollbar mt-4 h-full custom-scrollbar"
//       >
//         { !isCardView ? (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             {tasks.map((task) => {
//               const totalOrders = task.orders;
//               return task.orders.map((order) => (
//                 <MiniCards
//                   key={order.id}
//                   scard={task}
//                   markAsFlag={markAsFlag}
//                   task={order}
//                   totalOrders={totalOrders}
//                   dob={task.dob}
//                   loginuser={loginuser}
//                   insuranceName={task.insurancename}
//                   markAsComplete={markAsComplete}
//                   markAscancel={markAscancel}
//                   handleconfirmScheduleClick={handleconfirmScheduleClick}
//                   scheduleStates={scheduleStates}
//                   selectedOrder={selectedOrder}
//                   setSelectedOrder={setSelectedOrder}
//                   trigger={() => {
//                     fetchdata({
//                       dt: selectedDate.format("YYYY-MM-DD"),
//                       st: selectedStatus,
//                       ct: selectedCategory,
//                       searchQuery,
//                       isfilter: true,
//                     });
//                   }}
//                 />
//               ));
//             })}
//           </div>
//         ) : (
//           <div className="w-[100%] h-[100%] px-2">
//             {tasks.map((task) => (
//               <FullViewCard
//                 markAsFlag={markAsFlag}
//                 key={task.id}
//                 task={task}
//                 scheduleStates={scheduleStates}
//                 selectedOrder={selectedOrder}
//                 setSelectedOrder={setSelectedOrder}
//                 trigger={() => {
//                   fetchdata({
//                     dt: selectedDate.format("YYYY-MM-DD"),
//                     st: selectedStatus,
//                     ct: selectedCategory,
//                     searchQuery,
//                     isfilter: true,
//                   });
//                 }}
//                 fetchdata={fetchdata}
//                 markAsComplete={markAsComplete}
//                 markAscancel={markAscancel}
//                 handleconfirmScheduleClick={handleconfirmScheduleClick}
//               />
//             ))}
//           </div>
//         )}
//       </div>

//       </SideNavLayout>
//       {/* Calendar popup */}
//       {isCalendarOpen && (
//         <div
//           ref={calendarRef}
//           className="absolute top-1/4 lg:top-38 right-16 z-10"
//           style={{ maxWidth: "300px", width: "300px" }}
//         >
//           <DatePicker
//             selected={selectedDate.toDate()}
//             onChange={(date) => handleDateChange(dayjs(date))}
//             inline
//             calendarClassName="custom-calendar tasks-calendar"
//             showMonthDropdown
//             showYearDropdown
//             yearDropdownItemNumber={15}
//             dateFormat="MM/dd/yyyy"
//           />
//           <style>{`
//             .tasks-calendar.custom-calendar {
//               background-color: white;
//               border-radius: 10px;
//               box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//               padding: 16px;
//               font-family: inherit;
//               width: 100%;
//             }
//             .tasks-calendar .react-datepicker__header {
//               background-color: white;
//               border-bottom: none;
//               padding: 0 0 12px 0;
//             }
//             .tasks-calendar .react-datepicker__current-month {
//               font-size: 15px;
//               font-weight: 500;
//               color: #1D2951;
//               margin-bottom: 0;
//               padding-bottom: 8px;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//               gap: 20px !important;
//             }
//             .tasks-calendar .react-datepicker__current-month select {
//               appearance: none;
//               -webkit-appearance: none;
//               -moz-appearance: none;
//               background: white;
//               border: none;
//               font-size: 15px;
//               font-weight: 500;
//               color: #1D2951;
//               cursor: pointer;
//               padding-right: 28px;
//               background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%231D2951' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
//               background-repeat: no-repeat;
//               background-position: right center;
//               background-size: 10px 6px;
//               outline: none;
//             }
//             .tasks-calendar .react-datepicker__current-month select:focus,
//             .tasks-calendar .react-datepicker__current-month select:active,
//             .tasks-calendar .react-datepicker__current-month select:hover {
//               outline: none;
//               box-shadow: none;
//               color: #1D2951;
//               background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%231D2951' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
//             }
//             .tasks-calendar .react-datepicker__month-dropdown,
//             .tasks-calendar .react-datepicker__year-dropdown {
//               background-color: white;
//               border: 1px solid #e5e7eb;
//               border-radius: 6px;
//               padding: 4px;
//               box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
//               max-height: 200px;
//               overflow-y: auto;
//             }
//             .tasks-calendar .react-datepicker__year-dropdown {
//               height: 260px;
//               max-height: 260px;
//             }
//             .tasks-calendar .react-datepicker__month-option,
//             .tasks-calendar .react-datepicker__year-option {
//               padding: 6px 12px;
//               cursor: pointer;
//               font-size: 14px;
//               border-radius: 4px;
//               outline: none;
//               color: #1D2951;
//             }
//             .tasks-calendar .react-datepicker__month-option:focus,
//             .tasks-calendar .react-datepicker__year-option:focus {
//               outline: none;
//               box-shadow: none;
//             }
//             .tasks-calendar .react-datepicker__month-option:hover,
//             .tasks-calendar .react-datepicker__year-option:hover {
//               background-color: #f3f4f6;
//             }
//             .tasks-calendar .react-datepicker__month-option--selected,
//             .tasks-calendar .react-datepicker__year-option--selected {
//               background-color: #1D2951;
//               color: white;
//             }
//             .tasks-calendar .react-datepicker__day-names {
//               display: flex;
//               justify-content: space-around;
//               margin-bottom: 8px;
//               padding-top: 8px;
//             }
//             .tasks-calendar .react-datepicker__day-name {
//               width: 36px;
//               line-height: 36px;
//               margin: 0;
//               color: #6b7280;
//               font-size: 12px;
//               font-weight: 500;
//               text-align: center;
//             }
//             .tasks-calendar .react-datepicker__month { margin: 0; padding: 0; }
//             .tasks-calendar .react-datepicker__week {
//               display: flex;
//               justify-content: space-around;
//               margin-bottom: 4px;
//             }
//             .tasks-calendar .react-datepicker__day {
//               width: 34px;
//               height: 34px;
//               line-height: 36px;
//               margin: 0;
//               border-radius: 50%;
//               color: #111827;
//               font-size: 14px;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//             }
//             .tasks-calendar .react-datepicker__day:hover {
//               background-color: #f3f4f6;
//               border-radius: 50%;
//             }
//             .tasks-calendar .react-datepicker__day--selected,
//             .tasks-calendar .react-datepicker__day--keyboard-selected {
//               background-color: #1D2951 !important;
//               color: white !important;
//               border-radius: 50%;
//               font-weight: 500;
//             }
//             .tasks-calendar .react-datepicker__day--selected:hover,
//             .tasks-calendar .react-datepicker__day--keyboard-selected:hover {
//               background-color: #1D2951 !important;
//             }
//             .tasks-calendar .react-datepicker__day--today {
//               font-weight: 600;
//               border: 1px solid #1D2951;
//               border-radius: 50%;
//               box-sizing: border-box;
//             }
//             .tasks-calendar .react-datepicker__day--outside-month {
//               color: #d1d5db;
//             }
//             .tasks-calendar .react-datepicker__navigation {
//               top: 16px;
//               outline: none;
//               width: 32px;
//               height: 32px;
//               border-radius: 4px;
//             }
//             .tasks-calendar .react-datepicker__navigation:hover {
//               background-color: #f3f4f6;
//             }
//             .tasks-calendar .react-datepicker__navigation:focus {
//               outline: none;
//               box-shadow: none;
//             }
//             .tasks-calendar .react-datepicker__navigation-icon::before {
//               border-color: #111827;
//               border-width: 2px 2px 0 0;
//             }
//           `}</style>
//         </div>
//       )}
//       <Backdrop
//         sx={{
//           color: "secondary.main", // Sets the CircularProgress color to secondary
//           backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//         }}
//         open={loading}
//       >
//         <CircularProgress color="secondary" />
//       </Backdrop>
//       <ToastMessage
//         message={toastMessage}
//         severity={toastSeverity}
//         open={openToast}
//         handleClose={handleToastClose}
//       />
//       {taskFilter && (
//         <TaskFilter
//           selectedTab={selectedTab}
//           selectedStatus={selectedStatus}
//           setSelectedStatus={setSelectedStatus}
//           setSelectedCategory={setSelectedCategory}
//           selectedCategory={selectedCategory}
//           selectedDate={selectedDate}
//           setIsFilterApplied={setIsFilterApplied}
//           setSelectedDate={setSelectedDate}
//           setTaskFilter={setTaskFilter}
//           setSelectedTab={setSelectedTab}
//           fetchdata={fetchdata}
//         />
//       )}
//     </div>
//   );
// };

// export default Tasks;

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SideNavLayout from "../customsidenav/sidenavlayout";
import { faSearch, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useEffect, useRef, useState } from "react";
import { Backdrop, CircularProgress, Skeleton } from "@mui/material";
import TabsComponent from "../rpm/tabs";
import {
  BiList,
  BiListTask,
  MaterialSymbols,
} from "../utils/gridbuttons/gridbutton";
import calendericon from "../assets/auth/calendericon.svg";
import { customObjectToDateString } from "../dateutils/date";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MiniCards from "./cards/cards";
import FullViewCard from "./cards/fullcard";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import dayjs from "dayjs";
import api from "../api/api";
import { FilterAltOutlined } from "@mui/icons-material";
import { filteroutlined } from "../customsidenav/svgslist";
import isToday from "dayjs/plugin/isToday";
import ToastMessage from "../utils/mui/righttoptoast";
import { useSelector } from "react-redux";
import {
  inHouseSummaryToast,
  inHouseTasksToUpload,
  sendInHouseResults,
} from "./inhouseTestUpload";
import TaskTypeFilter, { filterTasksByType } from "./TaskTypeFilter";
import { isCoverageNote } from "../landingscreen/cards/visitflow";
import { getPracticeId } from "../config/practice";
import { CalendarPanel } from "../components/calendar/CalendarPanel";
import ConfirmDialog from "./Modals/ConfirmDialog";
import "./cards/taskcard.css";
dayjs.extend(isToday);

// Local status pills. The shared TabsComponent in src/rpm/tabs.jsx also dresses
// the RPM screen, so it is left alone.
const TaskStatusTabs = ({ tabs, selectedTab, onSelectTab }) => (
  <div className="flex items-center gap-3">
    {tabs.map((tab, index) => {
      const active = selectedTab === index;
      return (
        <button
          key={tab.label}
          type="button"
          aria-pressed={active}
          onClick={() => onSelectTab(index)}
          className={`flex items-center gap-2 rounded-full border px-4 py-2 font-inter text-[14px] font-medium transition-colors ${
            active
              ? "border-[#c8d9f3] bg-[#e8f0fb] text-[#1d3f8f]"
              : "border-[#e8ecf3] bg-white text-[#1d2951] hover:bg-[#f2f6fc] hover:border-[#d8dfec]"
          }`}
        >
          {tab.label}
          <span
            className={`flex h-[24px] min-w-[24px] items-center justify-center rounded-full px-1.5 text-[12px] font-semibold ${
              active ? "bg-white text-[#1d3f8f]" : "bg-[#eef1f6] text-[#5b6478]"
            }`}
          >
            {tab.count}
          </span>
        </button>
      );
    })}
  </div>
);

// The morning job's "The following are covered for this patient: ..." note is
// not a task to complete (it repeats the dashboard's coverage chips), so it is
// left out of every list here; a patient whose only row that day is that note
// drops out. The gateway filters it too; this keeps the page right either way.
const withoutCoverageNotes = (groups) =>
  (Array.isArray(groups) ? groups : []).reduce((acc, group) => {
    const orders = Array.isArray(group?.orders) ? group.orders : null;
    if (!orders) {
      acc.push(group);
      return acc;
    }
    const kept = orders.filter((o) => !isCoverageNote(o));
    if (orders.length > 0 && kept.length === 0) return acc;
    acc.push(kept.length === orders.length ? group : { ...group, orders: kept });
    return acc;
  }, []);

// Tab counts come from the gateway's tasks-top-count. Until it leaves coverage
// notes out, take off the ones this page has seen in the same day's lists
// (keyed by order id, so a note seen twice counts once). Once the gateway
// filters its lists, none are seen and nothing is taken off.
const COVERAGE_COUNT_RULES = {
  All: (n) => n.status !== "INFO",
  INFO: (n) => n.status === "CREATED",
  FLAGGED: (n) => n.flagged && n.status !== "INFO",
};
const tabsWithoutCoverageNotes = (tabs, countsDate, seen) => {
  if (!countsDate || !seen || seen.date !== countsDate) return tabs;
  const notes = Object.values(seen.byId || {});
  if (!notes.length) return tabs;
  return tabs.map((tab) => {
    const rule = COVERAGE_COUNT_RULES[tab.status];
    if (!rule) return tab;
    const less = notes.filter(rule).length;
    return less ? { ...tab, count: Math.max(0, (Number(tab.count) || 0) - less) } : tab;
  });
};

const Tasks = () => {
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const calendarRef = useRef(null);
  const [isCardView, setIsCardView] = useState(!false);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const today = new Date();
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [tasks, setTasks] = useState([]);
  console.log("tasks", tasks);

  const [originalTask, setOriginalTask] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const searchTimer = useRef(null);
  // In-house results that did not reach Athena during a bulk "Complete" run (shown in
  // the run's summary toast instead of being lost behind it).
  const bulkUploadFailures = useRef([]);
  const [selectedTask, setSelectedTask] = useState({});
  const [markascomplete, setMarkascomplete] = useState({});
  const [markcancel, setMarkcancel] = useState({});
  const [scheduleStates, setScheduleStates] = useState({});
  const [selectedOrder, setSelectedOrder] = useState(null);
  const practiseid = getPracticeId();
  const [selectedStatus, setSelectedStatus] = useState("");
  // Task type filter (TaskTypeFilter): applied on the client over whatever
  // the fetch and search left in `tasks`, so it survives refetches.
  const [selectedTypes, setSelectedTypes] = useState([]);
  const visibleTasks = filterTasksByType(tasks, selectedTypes);
  // Multi-select: ids of the open tasks ticked on the cards. The bulk bar acts
  // on them; anything that finishes or leaves the list drops out.
  const [selectedIds, setSelectedIds] = useState(() => new Set());
  const [bulkBusy, setBulkBusy] = useState(false);
  const [bulkConfirm, setBulkConfirm] = useState(null); // "complete" | "cancel"
  const [loginuser, setLoginuser] = useState({});
  const userConfig = useSelector((state) => state.userconfig);
  const [tabs, setTabs] = useState([
    { label: "All Tasks", width: 44, count: 0, status: "All" }, // Tab for "All Tasks"
    { label: "Pending", width: 64, count: 0, status: "INFO" }, // Tab for "Pending" tasks
    { label: "Flagged", width: 64, count: 0, status: "FLAGGED" }, // Assuming there's a Flagged tab
  ]);
  // Day of the counts in `tabs`, and the coverage notes seen in that day's
  // lists (see tabsWithoutCoverageNotes).
  const [countsDate, setCountsDate] = useState(null);
  const [coverageSeen, setCoverageSeen] = useState({ date: null, byId: {} });

  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const [toastSeverity, setToastSeverity] = useState("success");
  const handleToastClose = () => {
    setOpenToast(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setIsCalendarOpen(false);
      }
    };

    if (isCalendarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isCalendarOpen]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setIsCalendarOpen(false);
    fetchdbcounts(date);
    fetchdata({ dt: date.format("YYYY-MM-DD"), st: selectedFilter });
  };
  const fetchuser = async () => {
    try {
      const response = await api.get(`auth/me`);
      setLoginuser(response);
    } catch (error) {
      console.log(error);
    }
  };

  // Search matches EVERY field of a task, not just patient name/id: task
  // text, type (Refills/Labs/...), provider, status, diagnosis, insurance.
  // Multi-word queries AND together ("refill norco" = refill tasks w/ norco).
  const taskMatchesTokens = (group, order, tokens) => {
    const hay = [
      group.patient_name,
      group.patientid,
      group.insurancename,
      order.ordername,
      order.ordertype,
      order.provider_name,
      order.provider,
      order.status,
      order.diagnosis,
      order.roleval,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return tokens.every((t) => hay.includes(t));
  };

  const filterLocally = (source, query) => {
    const tokens = (query || "").trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (!tokens.length) return source;
    return source
      .map((group) => {
        const orders = (group.orders || []).filter((o) =>
          taskMatchesTokens(group, o, tokens),
        );
        return orders.length ? { ...group, orders } : null;
      })
      .filter(Boolean);
  };

  // Remember the coverage notes in a day's list (before they are filtered
  // out) so the tab counts can leave them out too.
  const noteCoverageNotes = (date, groups) => {
    const found = {};
    (Array.isArray(groups) ? groups : []).forEach((group) =>
      (Array.isArray(group?.orders) ? group.orders : []).forEach((o) => {
        if (isCoverageNote(o) && o?.id !== null && o?.id !== undefined) {
          found[o.id] = {
            status: String(o.status || "").trim().toUpperCase(),
            flagged: Number(o.is_flagged) === 1,
          };
        }
      }),
    );
    setCoverageSeen((prev) =>
      prev.date === date
        ? { date, byId: { ...prev.byId, ...found } }
        : { date, byId: found },
    );
  };

  const fetchdata = async ({
    dt = null,
    st = null,
    searchQuery = "",
    isfilter,
  }) => {
    // selectedDate.format('YYYY-MM-DD')
    if (st === null) {
      setSelectedTab(0);
    } else {
      setSelectedFilter(st);
    }
    setLoading(true);

    try {
      const payload = {
        orderdate: dt || selectedDate.format("YYYY-MM-DD"),
        search: "",
      };

      if (st) {
        payload.status = [st];
      } else {
        payload.status = ["All"];
      }

      const response = await api.post(`/v1/${practiseid}/tasks`, payload);

      // if (response.status == 200) {
      //   setTasks(response.data);
      //   setOriginalTask(response.data);
      //   if (isfilter) {
      //     const value = searchQuery.trim().toLowerCase(); // ensure case-insensitive and trimmed

      //     const filteredTasks = response.data.filter((task) => {
      //       const nameMatch = task.patient_name?.toLowerCase().includes(value);
      //       const idMatch = String(task.patientid).includes(value); // convert patientid to string
      //       return nameMatch || idMatch;
      //     });

      //     console.log(filteredTasks, " result -->searchterm", searchQuery);
      //     setTasks(filteredTasks);
      //   }
      // }
      if (response.status == 200) {
        noteCoverageNotes(payload.orderdate, response.data);
        // reverse safely without mutating; coverage notes are not tasks
        const reversed = withoutCoverageNotes([...response.data].reverse());

        setTasks(reversed);
        setOriginalTask(reversed);

        if (isfilter) {
          setTasks(filterLocally(reversed, searchQuery));
        }
      } else {
        setTasks([]);
        setOriginalTask([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const fetchdbcounts = async (dt) => {
    const payloaddate = dt
      ? dt.format("YYYY-MM-DD")
      : selectedDate.format("YYYY-MM-DD");
    try {
      const response = await api.get(
        `/v1/${practiseid}/tasks/tasks-top-count?st_date=${payloaddate}`,
      );
      const { alltaskOrderscnt, pendingtaskOrderscnt, flagtaskOrderscnt } =
        response.data;
      setCountsDate(payloaddate);
      setTabs((prevTabs) => [
        { ...prevTabs[0], count: alltaskOrderscnt },
        { ...prevTabs[1], count: pendingtaskOrderscnt },
        { ...prevTabs[2], count: flagtaskOrderscnt },
      ]);
    } catch (error) {
      console.error("Error fetching tasks count:", error);
    }
  };

  useEffect(() => {
    fetchuser();
  }, []);

  const handleSearchChange = (event) => {
    // keep the raw value in state (trimming here broke multi-word typing —
    // spaces vanished as you typed); normalize only when matching.
    const value = event.target.value;
    setSearchQuery(value);
    if (searchTimer.current) clearTimeout(searchTimer.current);
    setTasks(filterLocally(originalTask, value));
  };

  let user = localStorage.getItem("user");
  let firstName = localStorage.getItem("firstname");
  let lastName = localStorage.getItem("lastname");

  // opts.quiet: run without the toast and list refresh and return true/false
  // (the bulk bar runs several, then refreshes once).
  const markAsComplete = async (ids, task, { quiet = false } = {}) => {
    try {
      // Check if the task is an array or a single task object
      const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array

      if (!taskToProcess) {
        console.error("No task data available");
        return;
      }

      // Extract data from the task (using taskToProcess to ensure consistency)
      const fullName = `${firstName} ${lastName}`;
      const payload = {
        ids: ids,
        status: taskToProcess.status,
        notes: taskToProcess.notes,
        orderdate: dayjs(taskToProcess.ts).format("YYYY-MM-DD"),
        login_user: user,
        ordertype: taskToProcess.ordertype,
        ordername: taskToProcess.ordername,
        username: userConfig?.username,
      };

      // Make API call to mark as complete
      const response = await api.put(
        `/v1/${practiseid}/tasks/${taskToProcess.patientid}/mark_as_complete`,
        payload,
      );

      if (response.status === 200) {
        // In-house COVID/STREP/FLU tests (src/tasks/inhouseTestUpload.js): filed once
        // per test - the gateway answers a repeat with the copy already in Athena - and
        // a failed upload is resent by selecting the completed test and clicking again.
        // Every outcome goes into ONE toast; failures are red, never hidden (review 10-06).
        const taskList = Array.isArray(task) ? task : [task];
        const uploads = await sendInHouseResults({
          practiseid,
          tasks: inHouseTasksToUpload(ids, response, taskList),
          fallbackPatientid: taskToProcess.patientid,
        });
        setLoading(false);
        if (quiet) {
          if (uploads.failed) {
            bulkUploadFailures.current.push(...uploads.lines.filter((l) => l.includes("NOT sent")));
          }
          return true;
        }
        const summary = inHouseSummaryToast(response.message, uploads);
        setToastSeverity(summary.severity);
        setToastMessage(summary.message);
        setOpenToast(true);

        fetchdbcounts(selectedDate);
        const selected = tabs[selectedTab].status;
        fetchdata({
          dt: selectedDate.format("YYYY-MM-DD"),
          st: selected,
          searchQuery,
          isfilter: true,
        });
        console.log("Task marked as complete successfully");
      } else {
        if (quiet) return false;
        setToastSeverity("info");
        setToastMessage(response.message);
        setOpenToast(true);
        console.error("Error marking task as complete");
      }
    } catch (error) {
      if (quiet) return false;
      setToastSeverity("error");
      setToastMessage("Something Went Wrong");
      setOpenToast(true);
      console.error("Error marking task as complete:", error);
    }
  };

  const markAsFlag = async (ids, task, status, { quiet = false } = {}) => {
    try {
      // Check if the task is an array or a single task object
      const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array

      if (!taskToProcess) {
        console.error("No task data available");
        return;
      }

      const payload = {
        ids: ids,
        notes: taskToProcess.notes,
        st_date: dayjs(taskToProcess.ts).format("YYYY-MM-DD"),
        login_user: user,
      };
      let response;
      if (status === "FLAGGED") {
        response = await api.put(
          `/v1/${practiseid}/tasks/mark_as_unflagged`,
          payload,
        );
      } else {
        // Make API call to mark as complete
        response = await api.put(
          `/v1/${practiseid}/tasks/mark_as_flagged`,
          payload,
        );
      }

      if (response.status === 200) {
        if (quiet) return true;
        // Refetch the data after completing the task

        setToastSeverity("success");
        setToastMessage(response.message);
        setOpenToast(true);

        fetchdbcounts(selectedDate);
        const selected = tabs[selectedTab].status;
        fetchdata({
          dt: selectedDate.format("YYYY-MM-DD"),
          st: selected,
          searchQuery,
          isfilter: true,
        });
        console.log("Task marked as Flagged");
      } else {
        if (quiet) return false;
        setToastSeverity("info");
        setToastMessage(response.message);
        setOpenToast(true);
        console.error("Error While Flagging the task");
      }
    } catch (error) {
      if (quiet) return false;
      setToastSeverity("error");
      setToastMessage("Something Went Wrong");
      setOpenToast(true);
      console.error("Error marking task as complete:", error);
    }
  };
  const markAscancel = async (ids, task, { quiet = false } = {}) => {
    try {
      // Check if the task is an array or a single task object
      const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array

      if (!taskToProcess) {
        console.error("No task data available");
        return;
      }

      // Construct the payload for the cancel action
      const payload = {
        ids: ids, // Pass the task ids (task.id or array of ids)
        notes: taskToProcess.notes, // Use notes from the task
        st_date: dayjs(taskToProcess.ts).format("YYYY-MM-DD"), // Format the timestamp
        login_user: userConfig?.username, // Logged in user info
      };

      // Make API call to mark as decline (cancel)
      const response = await api.put(
        `/v1/${practiseid}/tasks/mark_as_decline`,
        payload,
      );

      if (response.status === 200) {
        if (quiet) return true;
        setToastSeverity("success");
        setToastMessage(response.message);
        setOpenToast(true);
        // Refetch or update data after the cancel action is successful
        console.log("Task marked as cancelled successfully");
        fetchdbcounts(selectedDate);
        const selected = tabs[selectedTab].status;
        fetchdata({
          dt: selectedDate.format("YYYY-MM-DD"),
          st: selected,
          searchQuery,
          isfilter: true,
        });
      } else {
        if (quiet) return false;
        setToastSeverity("info");
        setToastMessage(response.message);
        setOpenToast(true);
        console.error("Error marking task as cancelled");
      }
    } catch (error) {
      if (quiet) return false;
      setToastSeverity("error");
      setToastMessage("Something Went Wrong");
      setOpenToast(true);
      console.error("Error marking task as cancelled:", error);
    }
  };

  const handleconfirmScheduleClick = async (order) => {
    try {
      // Create the payload to send the status update

      const newStatusFlag = selectedOrder.schedule === "t" ? "f" : "t"; // Toggle status for this specific order

      console.log(newStatusFlag);
      setScheduleStates((prevState) => ({
        ...prevState,
        [order.id]: newStatusFlag, // Update only this specific order's status
      }));

      // Create the payload to send the status update
      const payload = {
        orderid: order.id,
        statusflag: newStatusFlag,
        login_user: user, // You can replace with the actual logged-in user
      };
      // Call API to update status flag
      const response = await api.put(
        `/v1/${practiseid}//tasks/update_status_schedule`,
        payload,
      );

      if (response.status === 200) {
        // If the update was successful, refresh data if necessary
        fetchdata({
          dt: selectedDate.format("YYYY-MM-DD"),
          st: selectedStatus,
          searchQuery,
          isfilter: true,
        });
        setScheduleStates({});
      } else {
        console.error("Error updating status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const taskPrivileges = useSelector((state) => state.userPrivileges.taskrpm) || [];
  // Same visibility rule as the cards: labs / schedule-rto / procedure rows
  // only for users with that task privilege.
  const isVisibleOrder = (o) => {
    const type = String(o?.ordertype || "").toLowerCase();
    const key = type === "procedure" ? "procedures" : type;
    return !(
      (type === "labs" || type === "schedule-rto" || type === "procedure") &&
      !taskPrivileges.some((p) => String(p).toLowerCase() === key)
    );
  };
  const isOpenOrder = (o) => !["COMPLETED", "CANCELLEDTASK"].includes(String(o?.status).toUpperCase());
  const openOrders = visibleTasks.flatMap((g) => (g.orders || []).filter((o) => isVisibleOrder(o) && isOpenOrder(o)));
  const selectedOrders = openOrders.filter((o) => selectedIds.has(String(o.id)));
  useEffect(() => {
    // drop ticks for tasks that are no longer open or listed
    setSelectedIds((prev) => {
      const open = new Set(openOrders.map((o) => String(o.id)));
      const next = new Set([...prev].filter((id) => open.has(id)));
      return next.size === prev.size ? prev : next;
    });
  }, [tasks, selectedTypes]);
  const toggleOrder = (order) =>
    setSelectedIds((prev) => {
      const next = new Set(prev);
      const id = String(order.id);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  const togglePatient = (orders, select) =>
    setSelectedIds((prev) => {
      const next = new Set(prev);
      orders.forEach((o) => (select ? next.add(String(o.id)) : next.delete(String(o.id))));
      return next;
    });
  const runBulk = async (kind) => {
    const list = selectedOrders;
    if (!list.length) return;
    setBulkBusy(true);
    bulkUploadFailures.current = [];
    let ok = 0;
    for (const o of list) {
      const id = [String(o.id)];
      let done;
      if (kind === "complete") done = await markAsComplete(id, o, { quiet: true });
      else if (kind === "cancel") done = await markAscancel(id, o, { quiet: true });
      else done = o.status === "FLAGGED" ? true : await markAsFlag(id, o, o.status, { quiet: true });
      if (done) ok += 1;
    }
    setBulkBusy(false);
    setSelectedIds(new Set());
    const verb = kind === "complete" ? "completed" : kind === "cancel" ? "cancelled" : "flagged";
    const uploadFailures = bulkUploadFailures.current;
    bulkUploadFailures.current = [];
    setToastSeverity(uploadFailures.length ? "error" : ok === list.length ? "success" : "info");
    setToastMessage(
      (ok === list.length
        ? `${ok} ${ok === 1 ? "task" : "tasks"} ${verb}`
        : `${ok} of ${list.length} tasks ${verb}; the rest could not be updated`) +
        (uploadFailures.length
          ? ` | ${uploadFailures.join(" | ")} | Open the task, select the test and click Mark as Complete to resend it.`
          : ""),
    );
    setOpenToast(true);
    fetchdbcounts(selectedDate);
    fetchdata({
      dt: selectedDate.format("YYYY-MM-DD"),
      st: tabs[selectedTab].status,
      searchQuery,
      isfilter: true,
    });
  };

  useEffect(() => {
    fetchdbcounts();
    fetchdata({ dt: selectedDate.format("YYYY-MM-DD"), searchQuery });
  }, []);

  const displayTabs = tabsWithoutCoverageNotes(tabs, countsDate, coverageSeen);

  return (
    <div className="h-full px-6 py-5">
      {/* Search bar */}
      <SideNavLayout>
        <div className="bmtk-zoom">
        {/* One toolbar row: status tabs on the left, then type, search, scope
            and date. The filter icon is gone - type and status cover it. */}
        <div className="w-full flex flex-wrap items-center gap-3 mb-[12px]">
          <div className="flex items-center gap-3 mr-auto">
            <span className="font-inter text-[11px] font-semibold uppercase tracking-[0.9px] text-[#8A94A4]">
              Task status
            </span>
              <TaskStatusTabs
                tabs={displayTabs}
                selectedTab={selectedTab}
                onSelectTab={(index) => {
                  setSelectedTab(index);
                  const selectedStatus = tabs[index].status;
                  setSearchQuery("");
                  setSelectedStatus("");
                  setTasks([]);
                  fetchdata({
                    dt: selectedDate.format("YYYY-MM-DD"),
                    st: selectedStatus,
                    searchQuery,
                  });
                  fetchdbcounts(selectedDate);
                }}
              />
          </div>
          <TaskTypeFilter
            tasks={tasks}
            selected={selectedTypes}
            setSelected={setSelectedTypes}
          />
          <div className="flex items-center bg-white border border-[#E3E8EF] rounded-full flex-1 min-w-[240px] max-w-[380px] px-2 shadow-sm">
            <FontAwesomeIcon icon={faSearch} className="text-gray-400 ml-3" />
            <input
              type="text"
              className="flex-grow bg-transparent py-2 pl-2 pr-1 font-inter text-[14px] outline-none"
              placeholder="Search patient, task, or staff"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            {searchQuery && (
              <button
                className="px-2 text-gray-400 hover:text-gray-600"
                title="Clear search"
                onClick={() => {
                  setSearchQuery("");
                  if (searchTimer.current) clearTimeout(searchTimer.current);
                  setTasks(originalTask);
                }}
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            )}
          </div>
          {/* Search filters the selected day only; the cross-date "All dates"
              search was removed (owner decision 2026-10-02). */}
              <div
                onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                className="flex flex-col items-start justify-start px-2 py-1 bg-white rounded-[10px] cursor-pointer"
              >
                {/* <div className="text-sm">
                    {selectedDate
                      ? customObjectToDateString(selectedDate)
                      : new Date().toISOString().split("T")[0]}
                  </div> */}
                <span className="text-[10px] text-[#1D2951] font-worksans font-medium">
                  {dayjs(selectedDate).isSame(dayjs(), "day")
                    ? "Today"
                    : dayjs(selectedDate).format("dddd")}
                </span>
                <div className="flex justify-between items-center gap-2">
                  <div className="text-sm">
                    {selectedDate
                      ? selectedDate.format("MM.DD.YYYY")
                      : dayjs().format("MM.DD.YYYY")}
                  </div>

                  <img
                    className="w-5 h-5"
                    alt="Calendar Icon"
                    src={calendericon}
                  />
                </div>
              </div>
        </div>

        {/* Cards Section - Scrollable */}
        <div className="w-full flex flex-wrap gap-6 custom-scrollbar mt-4 h-full custom-scrollbar">
          {!isCardView ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {visibleTasks.map((task) => {
                const totalOrders = task.orders;
                return task.orders.map((order) => (
                  <MiniCards
                    key={order.id}
                    scard={task}
                    markAsFlag={markAsFlag}
                    task={order}
                    totalOrders={totalOrders}
                    dob={task.dob}
                    loginuser={loginuser}
                    insuranceName={task.insurancename}
                    markAsComplete={markAsComplete}
                    markAscancel={markAscancel}
                    handleconfirmScheduleClick={handleconfirmScheduleClick}
                    scheduleStates={scheduleStates}
                    selectedOrder={selectedOrder}
                    setSelectedOrder={setSelectedOrder}
                    trigger={() => {
                      fetchdata({
                        dt: selectedDate.format("YYYY-MM-DD"),
                        st: selectedStatus,
                        searchQuery,
                        isfilter: true,
                      });
                    }}
                  />
                ));
              })}
            </div>
          ) : (
            <div className="w-[100%] h-[100%] px-2">
              {visibleTasks.map((task) => (
                <FullViewCard
                  selectedIds={selectedIds}
                  onToggleOrder={toggleOrder}
                  onTogglePatient={togglePatient}
                  markAsFlag={markAsFlag}
                  key={task.id}
                  task={task}
                  scheduleStates={scheduleStates}
                  selectedOrder={selectedOrder}
                  setSelectedOrder={setSelectedOrder}
                  trigger={() => {
                    fetchdata({
                      dt: selectedDate.format("YYYY-MM-DD"),
                      st: selectedStatus,
                      searchQuery,
                      isfilter: true,
                    });
                  }}
                  fetchdata={fetchdata}
                  markAsComplete={markAsComplete}
                  markAscancel={markAscancel}
                  handleconfirmScheduleClick={handleconfirmScheduleClick}
                />
              ))}
            </div>
          )}
        </div>
        </div>
      </SideNavLayout>
      {/* Calendar popup */}
      {isCalendarOpen && (
        <div
          ref={calendarRef}
          className="absolute top-1/4 lg:top-38 right-16 z-10"
          style={{ maxWidth: "300px", width: "300px" }}
        >
          <CalendarPanel
            value={selectedDate}
            onChange={(d) => handleDateChange(dayjs(d))}
          />
        </div>
      )}
      <Backdrop
        sx={{
          color: "secondary.main", // Sets the CircularProgress color to secondary
          backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
      {selectedOrders.length > 0 && (
        <div className="bmtk-bulk" role="toolbar" aria-label="Selected tasks">
          <span className="bmtk-bulk-count">{selectedOrders.length} selected</span>
          {selectedOrders.length < openOrders.length && (
            <button
              type="button"
              className="bmtk-bulk-all"
              onClick={() => setSelectedIds(new Set(openOrders.map((o) => String(o.id))))}
            >
              Select all {openOrders.length}
            </button>
          )}
          {taskPrivileges.includes("Mark Completed") && (
            <button type="button" className="bmtk-bulk-btn primary" disabled={bulkBusy} onClick={() => setBulkConfirm("complete")}>
              <svg fill="none" stroke="currentColor" strokeWidth="2.6" viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
              Complete
            </button>
          )}
          <button type="button" className="bmtk-bulk-btn" disabled={bulkBusy} onClick={() => runBulk("flag")}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" aria-hidden="true"><path d="M5 21V4m0 0h11l-2 4 2 4H5" strokeLinejoin="round" /></svg>
            Flag
          </button>
          {taskPrivileges.includes("Cancel Task") && (
            <button type="button" className="bmtk-bulk-btn" disabled={bulkBusy} onClick={() => setBulkConfirm("cancel")}>
              <svg fill="none" stroke="currentColor" strokeWidth="2.4" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
              Cancel tasks
            </button>
          )}
          <button type="button" className="bmtk-bulk-x" aria-label="Clear selection" title="Clear selection" onClick={() => setSelectedIds(new Set())}>
            ×
          </button>
        </div>
      )}
      <ConfirmDialog
        open={Boolean(bulkConfirm)}
        title={bulkConfirm === "cancel" ? "Cancel Tasks" : "Complete Tasks"}
        description={
          bulkConfirm === "cancel"
            ? `Are you sure you want to cancel ${selectedOrders.length} ${selectedOrders.length === 1 ? "task" : "tasks"}?`
            : `Are you sure you want to mark ${selectedOrders.length} ${selectedOrders.length === 1 ? "task" : "tasks"} as complete?`
        }
        cancelLabel="Keep Tasks"
        confirmLabel={bulkConfirm === "cancel" ? "Yes, Cancel Tasks" : "Yes, Complete Tasks"}
        variant={bulkConfirm === "cancel" ? "danger" : "success"}
        onConfirm={() => {
          const kind = bulkConfirm;
          setBulkConfirm(null);
          runBulk(kind);
        }}
        onClose={() => setBulkConfirm(null)}
      />
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />
    </div>
  );
};

export default Tasks;
